var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.3438V16.7188M11.0937 12.7143C11.0937 10.6567 12.7664 9 14.8437 9C16.1378 9 17.2748 9.64285 17.9482 10.625M11.25 13.3333C10.5625 13.3333 10 13.8905 10 14.5714V20.7619C10 21.4429 10.5625 22 11.25 22H18.75C19.4375 22 20 21.4429 20 20.7619V14.5714C20 13.8905 19.4375 13.3333 18.75 13.3333H11.25Z",
    stroke: "#616874",
    strokeWidth: 1.38889,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.68c379012cc3a3a49e926e4abfd7059d.svg";
export { ForwardRef as ReactComponent };